import {
    LOAD_VIDEO_REPORT, LOADING,
    PUT_VIDEO_REPORT,
    SORT_VIDEO_REPORT
} from './actions'
import {durationFromCliptime} from "../../../utilities/duration";

const inititalState = {
    loading: false,
    video_report: [],
    video_duration: ''
}

const reducer = (state = inititalState, { type, payload }) => {
    switch (type) {

        case SORT_VIDEO_REPORT:
            if (payload.sort_type === "timestamp") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.timestamp < b.timestamp) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.timestamp > b.timestamp) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }

            } else if (payload.sort_type === "name") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.name < b.name) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.name > b.name) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }
            } else if (payload.sort_type === "list") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.playlistname < b.playlistname) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.playlistname > b.playlistname) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }
            } else if (payload.sort_type === "sync_start_time") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.startsync < b.startsync) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.startsync > b.startsync) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }
            } else if (payload.sort_type === "ip") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.lip < b.lip) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.lip > b.lip) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }
            } else if (payload.sort_type === "error") {
                return {
                    ...state,
                    video_report:
                        Array.from(state.video_report).sort((a, b) => {
                            if (a.lasterror < b.lasterror) {
                                return payload.direction === "up" ? -1 : 1
                            }
                            if (a.lasterror > b.lasterror) {
                                return payload.direction === "up" ? 1 : -1
                            }
                            return 0
                        }),
                }
            }
        case LOAD_VIDEO_REPORT:
            return {
                ...state,
            }
        case PUT_VIDEO_REPORT:
            return {
                ...state,
                video_report: payload.video_report,
                video_duration: durationFromCliptime(payload.video_report)
            }

        case LOADING:
            return {
                ...state,
                loading: payload
            }


    }
    return state
}

export default reducer